const SERIALIZABLE_CHECK_IGNORED_ACTIONS = [
  "##axios/REQUEST_SENT",
  "##axios/RESPONSE_RECEIVED",
  "##api/REQUEST_SENT",
  "##api/RESPONSE_RECEIVED"
];

export default SERIALIZABLE_CHECK_IGNORED_ACTIONS;
